module.exports = __webpack_public_path__ + "img/image_06.2f1b41b8.jpg";